import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-change-exam-status',
  templateUrl: './change-exam-status.component.html',
  styleUrls: ['./change-exam-status.component.scss']
})
export class ChangeExamStatusComponent implements OnInit {

  constructor(private popoverRef: PopoverRef<any>, private examSchService: ExamScheduleService, private snackBar: SnackbarService,) { }
  examStatuses = [
    'Pending',
    'InProgress',
    'Finished',
    'TimeElapsed',
    'Stopped',
    'Disqualified',
  ]
  selectedStatus: string;
  ngOnInit(): void {
  }

  close(){
    this.popoverRef.close();
  }

  async yesClicked(){
    let data = {
        ids: this.examSchService.selectedIds.map(x => parseInt(x)),
        status: this.selectedStatus
      }
    const res = await this.examSchService.changeStatus(data) as any[];
      if(res !== null && res.length > 0){
        res.forEach(e =>{
          this.snackBar.error(e);
        })        
      }
      else{
        this.snackBar.success('Status Changed Successfully!');
      }
      this.examSchService.reloadGrid.next(true);
    this.close();
  }

  noClicked(){
    this.close();
  }

  onChange(event){
    this.selectedStatus = event.target.value;//ExaminationStatus[event.target.value];
  }
}
